module.exports = __webpack_public_path__ + "img/draw-banner.8443c93f.png";